/**
 * What a rejected sign-up or password reset says, taken from the server's message. The forms used to show that
 * message as it is: English, with internal names, and for the email check the address that was typed. The client
 * matches on the message text, like it does for EMAIL_NOT_VERIFIED.
 */
export type AuthErrorKind = 'password' | 'email' | 'other';

export function classifyAuthError(err: unknown): AuthErrorKind {
  const message = String((err as { message?: unknown } | null)?.message ?? err);
  if (/password must contain/i.test(message)) return 'password';
  if (/email .* is not valid/i.test(message)) return 'email';
  return 'other';
}
